import { FC } from 'react'
import clsx from 'classnames'
import { useLocale } from 'use-intl'
import { Link } from '@/routing'
import { Text } from '@/shared/ui'
import style from './searchItem.module.scss'

type SearchItemProps = {
  title: string
  content: string
  setInputValue: (value: string) => void
  url: string
  category?: {
    name: string
    color: string
    slug: string
  }
}

export const SearchItem: FC<SearchItemProps> = ({ title, content, category, url, setInputValue }) => {
  const handleInputValue = () => {
    setInputValue(title)
  }
  const currentLocale = useLocale()
  return (
    <Link href={url} target={'_blank'} onClick={handleInputValue} className={style.searchResultItem}>
      <div
        className={clsx(style.text, 'text', 'text_color_dark', 'text_type_t1')}
        dangerouslySetInnerHTML={{ __html: content }}
      />
      <div className={style.secondRow}>
        {category && (
          <Text type="d" color={category?.slug === 'announcements' ? 'green' : 'main-blue'}>
            {category?.name}
          </Text>
        )}
        <Text className={style.text} color={'dark-040'} type="d">
          {title}
        </Text>
      </div>
    </Link>
  )
}
